
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const mockInstances = [
  {
    id: 'inst-1',
    name: 'Main Business',
    domain: 'main.example.com',
    status: 'active',
    createdAt: new Date(2025, 1, 15)
  },
  {
    id: 'inst-2',
    name: 'Marketing Site',
    domain: 'marketing.example.com',
    status: 'active',
    createdAt: new Date(2025, 2, 10)
  },
  {
    id: 'inst-3',
    name: 'Support Portal',
    domain: 'support.example.com',
    status: 'active',
    createdAt: new Date(2025, 3, 1)
  }
];

const AdminInstancesTable: React.FC = () => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Instance Name</TableHead>
            <TableHead>Domain</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Created On</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {mockInstances.map((instance) => (
            <TableRow key={instance.id}>
              <TableCell className="font-medium">{instance.name}</TableCell>
              <TableCell>{instance.domain}</TableCell>
              <TableCell>
                <Badge variant={instance.status === 'active' ? 'default' : 'secondary'}>
                  {instance.status === 'active' ? 'Active' : 'Inactive'}
                </Badge>
              </TableCell>
              <TableCell>{instance.createdAt.toLocaleDateString()}</TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => window.open(`https://${instance.domain}`, '_blank')}
                >
                  <ExternalLink className="h-4 w-4 mr-1" />
                  Open
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default AdminInstancesTable;
